import { useEffect, useRef, useCallback } from 'react';

const EVENTS = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
const TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

/**
 * Logs out user after specified inactivity time (default 30 min).
 * Resets timer on mouse, keyboard, scroll, touch.
 */
export default function useInactivityLogout(logout, enabled = true, timeoutMs = TIMEOUT_MS) {
  const timerRef = useRef(null);

  const resetTimer = useCallback(() => {
    if (!enabled) return;
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      logout();
    }, timeoutMs);
  }, [logout, enabled, timeoutMs]);

  useEffect(() => {
    if (!enabled) return;
    resetTimer();
    EVENTS.forEach((ev) => window.addEventListener(ev, resetTimer));
    return () => {
      EVENTS.forEach((ev) => window.removeEventListener(ev, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [enabled, resetTimer]);
}
